export type ReviewTenantMismatch = 'review_tenant' | 'staging_path';

export function stagingPathTenantId(path: string | null | undefined): string | null {
  const clean = path?.replace(/^fiscal-photo-staging\//, '').trim();
  if (!clean) return null;
  const firstSegment = clean.split('/')[0]?.trim();
  return firstSegment || null;
}

export function reviewTenantMismatch(args: {
  activeTenantId: string | null | undefined;
  reviewTenantId: string | null | undefined;
  imageStoragePath?: string | null;
}): ReviewTenantMismatch | null {
  if (!args.activeTenantId) return 'review_tenant';
  if (args.reviewTenantId && args.reviewTenantId !== args.activeTenantId) {
    return 'review_tenant';
  }
  const pathTenantId = stagingPathTenantId(args.imageStoragePath);
  if (pathTenantId && pathTenantId !== args.activeTenantId) {
    return 'staging_path';
  }
  return null;
}
